











































































































































































import { Mixins, Component, Prop, Watch } from 'vue-property-decorator';
import { AxPage } from '@/mixins';

import * as I from '@/interfaces';
import * as U from '@/utils';

import AxAPI from '@/api';
import { TempEmployee } from '@/interfaces';

type Group = I.AxZone;

type PageInfo = I.MealSettingPageInfo;

type CardList = {};
type CashList = {};

type DataItem = U.DataItem<I.TempStaffInfo, State>;
type DataStore = U.DataStore<I.TempStaffInfo>;

type UpdateItemParam = I.PacketMealTimeUpdate;

const DataStore = U.DataStore;

class State {
  staffUserId: number;
  staffUpdateIndex: number;
  empno: string;
  name: string;
  uid: string;
  telNo: string;
  email: string;
  companyName: string;
  deptNameA: string;
  deptNameB: string;
  dutyNameA: string;
  userTypeName: string;
  userStatusName: string;
  isAntipass: boolean;
  isAdmin: boolean;
  isEscort: boolean;
  periodFrom: Date;
  periodTo: Date;
  timeFrom: string;
  timeTo: string;
  listDoor: I.DoorAuthSendData[];
  listGroup: I.DoorAuthSendData[];
  listUserStatus: I.CodeData[];
  listUserType: I.CodeData[];
  tempCardNo: string;
  tempCardName: string;
  tempCompanyCode: string;
  tempCompanyName: string;
  tempDeptCodeA: string;
  tempDeptNameA: string;
  tempUserId: number;
  tempUpdateIndex: number;
  seqNo: number;

  constructor() {
    this.staffUserId = -1;
    this.staffUpdateIndex = 0;
    this.empno = '';
    this.name = '';
    this.uid = '';
    this.telNo = '';
    this.email = '';
    this.companyName = '';
    this.deptNameA = '';
    this.deptNameB = '';
    this.dutyNameA = '';
    this.userStatusName = '';
    this.userTypeName = '';
    this.isAntipass = false;
    this.isAdmin = false;
    this.isEscort = false;
    this.periodFrom = new Date();
    this.periodTo = new Date(2050, 11, 31, 23, 59, 0);
    this.timeFrom = '';
    this.timeTo = '';
    this.listDoor = [];
    this.listGroup = [];
    this.listUserStatus = [];
    this.listUserType = [];
    this.tempCardNo = '';
    this.tempCardName = '';
    this.tempCompanyCode = '';
    this.tempDeptCodeA = '';
    this.tempCompanyName = '';
    this.tempDeptNameA = '';
    this.tempUserId = -1;
    this.tempUpdateIndex = 0;
    this.seqNo = -1;
  }
}

abstract class BaseClass extends Mixins(AxPage) {
  API!: AxAPI;
  pageInfo!: PageInfo;
  dataItem!: DataItem;
}

interface BaseInterface extends BaseClass {}

@Component
class ApiHandler extends BaseClass {
  callback!: Function;

  async getPageInfo() {
    const result = await this.API.call.meal.configGet();
    console.log('page', result);
    if (result instanceof Error) {
      await this.handleError(result);
      return false;
    } else {
      return result.data;
    }
  }

  makeTempStaffPacket(): I.PacketTempStaffIssue {
    return {
      seqNo: this.dataItem.state.seqNo,
      tempUserId: this.dataItem.state.tempUserId,
      tempUpdateIndex: this.dataItem.state.tempUpdateIndex,
      tempName: this.dataItem.state.tempCardName,
      tempCompanyCode: this.dataItem.state.tempCompanyCode,
      tempCompany: this.dataItem.state.tempCompanyName,
      tempDivisionCode: this.dataItem.state.tempDeptCodeA,
      tempDivision: this.dataItem.state.tempDeptNameA,
      issueFlag: 'U',
      staffUserId: this.dataItem.state.staffUserId,
      staffUpdateIndex: this.dataItem.state.staffUpdateIndex,
      issueDateTime: `${U.formatTime(
        this.dataItem.state.periodFrom.toISOString(),
        'YYYY-MM-DD'
      )}T00:00:00.000Z`,
      returnDateTime: `${U.formatTime(
        this.dataItem.state.periodTo.toISOString(),
        'YYYY-MM-DD'
      )}T23:59:00.000Z`
    };
  }

  async TempStaffSave(packet: I.PacketTempStaffIssue) {
    this.setLoading(true);
    const result = await this.API.call.temp.tempStaffSave(packet);
    this.setLoading(false);
    if (result instanceof Error) {
      await this.handleError(result);
      return false;
    } else {
      return result.data;
    }
  }

  async onSaveCard() {
    const packet = await this.makeTempStaffPacket();
    console.log('packet', packet);
    if (!packet) return;
    this.setLoading(true);
    const result = await this.TempStaffSave(packet);
    this.setLoading(false);
    if (result instanceof Error) {
      await this.handleError(result);
      return false;
    } else {
      await this.showErrorModal('정보', '반납 되었습니다.');
      return result;
    }
  }

  async onSaveClicked() {
    if (!this.dataItem.state.empno) {
      await this.showErrorModal('오류', '사원번호를 입력 해주세요.');
      return;
    }
    await this.onSaveCard();
    await this.callback();
    this.on = false;
  }
}

@Component
class DataItemHandler extends BaseClass {
  dataItems: DataItem[] = [
    {
      name: '카드',
      store: {} as DataStore,
      search: '',
      description: [],
      state: new State()
    }
  ];

  get dataItem() {
    return this.dataItems[0];
  }
}

@Component
class DialogHandler extends BaseClass {
  showEmployeeSearchDialog() {
    type EmployeeSearchDialogParams = { param: I.DataParam };

    const dialogParams = new I.DialogParam<EmployeeSearchDialogParams>(
      'AxSearchTempEmployeeDialog',
      {
        param: {
          items: [],
          selected: [],
          callback: async () => {
            const selected = dialogParams.props.param.selected[0] as I.TempEmployee;
            if (!selected) return;
            console.log('select', selected);
            this.dataItem.state.empno = selected.empno;
            this.dataItem.state.name = selected.name;
            this.dataItem.state.companyName = selected.companyName;
            this.dataItem.state.deptNameA = selected.deptNameA;
            this.dataItem.state.deptNameB = selected.deptNameB;
            this.dataItem.state.dutyNameA = selected.dutyNameA;
            this.dataItem.state.userTypeName = selected.userTypeName;
            this.dataItem.state.userStatusName = selected.userStatusName;
            this.dataItem.state.telNo = selected.telNo;
            this.dataItem.state.email = selected.email;
            this.dataItem.state.staffUserId = selected.userId;
            this.dataItem.state.staffUpdateIndex = selected.updateIndex;
            this.dataItem.state.periodFrom = new Date(selected.periodFrom);
            this.dataItem.state.periodTo = new Date(selected.periodTo);
          }
        }
      }
    );
    this.showDialog(dialogParams);
  }

  showTempCardSearchDialog() {
    type TempCardSearchDialogParams = { param: I.DataParam };

    const dialogParams = new I.DialogParam<TempCardSearchDialogParams>('AxTempCardSearchDialog', {
      param: {
        items: [],
        selected: [],
        callback: async () => {
          const selected = dialogParams.props.param.selected[0] as I.TempEmployee;
          if (!selected) return;
          console.log('select', selected);
          this.dataItem.state.tempCardNo = selected.cardNo;
          this.dataItem.state.tempCardName = selected.name;
          this.dataItem.state.tempCompanyCode = selected.companyCode;
          this.dataItem.state.tempCompanyName = selected.companyName;
          this.dataItem.state.tempDeptCodeA = selected.deptCodeA;
          this.dataItem.state.tempDeptNameA = selected.deptNameA;
          this.dataItem.state.tempUserId = selected.userId;
          this.dataItem.state.tempUpdateIndex = selected.updateIndex;
        }
      }
    });
    this.showDialog(dialogParams);
  }
}

@Component
class BaseData extends Mixins(AxPage) implements BaseInterface {
  dataItem!: DataItem;

  on = true;
  width = 1020;
  height = 480;

  pageInfo = {} as I.MealSettingPageInfo;

  @Prop({ type: Function, default: () => {} })
  callback!: Function;

  @Prop({ type: Object, default: () => {} })
  staffList!: I.TempStaffHistoryList;

  @Watch('on')
  onSwitchChanged() {
    this.$emit('changed', this.on);
  }

  get periodFrom() {
    return this.formatTime(this.dataItem.state.periodFrom.toISOString(), 'YYYY-MM-DD');
  }

  set periodFrom(date: string) {
    this.dataItem.state.periodFrom = new Date(date);
  }

  get periodTo() {
    return this.formatTime(this.dataItem.state.periodTo.toISOString(), 'YYYY-MM-DD');
  }

  set periodTo(date: string) {
    this.dataItem.state.periodTo = new Date(date);
  }
}

const Handlers = Mixins(Mixins(ApiHandler, DataItemHandler, DialogHandler));

@Component
export default class AxTempStaffReturnDialog extends Mixins(BaseData, Handlers) {
  async prepare() {
    console.log('staff', this.staffList);
    this.dataItem.state.seqNo = this.staffList.seqNo;
    this.dataItem.state.empno = this.staffList.empNo;
    this.dataItem.state.name = this.staffList.name;
    this.dataItem.state.userTypeName = this.staffList.userTypeName;
    this.dataItem.state.userStatusName = this.staffList.userStatusName;
    this.dataItem.state.companyName = this.staffList.companyName;
    this.dataItem.state.deptNameA = this.staffList.deptnamea;
    this.dataItem.state.deptNameB = this.staffList.deptnameb;
    this.dataItem.state.dutyNameA = this.staffList.dutynamea;
    this.dataItem.state.tempCardName = this.staffList.tempName;
    this.dataItem.state.tempCardNo = this.staffList.tempCardNo;
    this.dataItem.state.tempCompanyCode = this.staffList.tempCompanyCode;
    this.dataItem.state.tempCompanyName = this.staffList.tempCompany;
    this.dataItem.state.tempDeptCodeA = this.staffList.tempDivisionCode;
    this.dataItem.state.tempDeptNameA = this.staffList.tempDivision;
    this.dataItem.state.staffUserId = this.staffList.staffUserID;
    this.dataItem.state.tempUserId = this.staffList.tempUserID;
    this.dataItem.state.tempUpdateIndex = this.staffList.tempUpdateIndex;
    this.dataItem.state.staffUpdateIndex = this.staffList.staffUpdateIndex;
    this.dataItem.state.periodFrom = new Date(this.staffList.periodFrom.substring(0, 10));
    this.dataItem.state.periodTo = new Date(this.staffList.periodTo.substring(0, 10));
    // const pageInfo = await this.getPageInfo();
    // if (pageInfo) {
    //   this.pageInfo = pageInfo;
    // }
  }

  upload() {
    console.log('upload');
  }
}
